// DO NOT EDIT -- generated from fs/services/fieldmeta/customschema.proto

import * as protobuf from '../../../google/protobuf';
import * as vars from '../../api/vars';

export namespace CustomSchemaService {

  export const GetCustomSchemaEndpoint = "/grpc/fieldmeta.CustomSchemaService/GetCustomSchema";
  /** Retrieves the latest custom schema for an org. */
  export function GetCustomSchema(sender: (req: GetCustomSchemaRequest, endpoint: string) => Promise<GetCustomSchemaInternalResponse>, req: GetCustomSchemaRequest): { promise: () => Promise<GetCustomSchemaInternalResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCustomSchemaEndpoint),
      endpoint: GetCustomSchemaEndpoint
    };
  }

  export const GetCustomSchemaConnectionsEndpoint = "/grpc/fieldmeta.CustomSchemaService/GetCustomSchemaConnections";
  /** Retrieves the latest custom schema connections for an org. */
  export function GetCustomSchemaConnections(sender: (req: GetCustomSchemaConnectionsRequest, endpoint: string) => Promise<GetCustomSchemaConnectionsResponse>, req: GetCustomSchemaConnectionsRequest): { promise: () => Promise<GetCustomSchemaConnectionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCustomSchemaConnectionsEndpoint),
      endpoint: GetCustomSchemaConnectionsEndpoint
    };
  }

  export const GetCustomSchemaConnectionsByPropertyEndpoint = "/grpc/fieldmeta.CustomSchemaService/GetCustomSchemaConnectionsByProperty";
  /**
   * Retrieves the latest custom schema connections for an org by property.
   * If possible, prefer GetCustomSchemaConnections by parent as it's cheaper and more efficient.
   */
  export function GetCustomSchemaConnectionsByProperty(sender: (req: GetCustomSchemaConnectionsByPropertyRequest, endpoint: string) => Promise<GetCustomSchemaConnectionsResponse>, req: GetCustomSchemaConnectionsByPropertyRequest): { promise: () => Promise<GetCustomSchemaConnectionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCustomSchemaConnectionsByPropertyEndpoint),
      endpoint: GetCustomSchemaConnectionsByPropertyEndpoint
    };
  }

  export const IndexCustomSchemaEndpoint = "/grpc/fieldmeta.CustomSchemaService/IndexCustomSchema";
  /**
   * Attempts to index the provided custom schema fields.
   * For fields that already exist, a no-op occurs (outside of possibly updating a little metadata).
   * If only a subset of the fields are accepted, the response will indicate which ones are allowed to be used/indexed during ingestion.
   */
  export function IndexCustomSchema(sender: (req: IndexCustomSchemaRequest, endpoint: string) => Promise<IndexCustomSchemaResponse>, req: IndexCustomSchemaRequest): { promise: () => Promise<IndexCustomSchemaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, IndexCustomSchemaEndpoint),
      endpoint: IndexCustomSchemaEndpoint
    };
  }
}

export namespace CustomSchemaServicePublic {

  export const GetCustomSchemaEndpoint = "/grpc/fieldmeta.CustomSchemaServicePublic/GetCustomSchema";
  /** Retrieves the latest custom schema for an org. */
  export function GetCustomSchema(sender: (req: GetCustomSchemaRequest, endpoint: string) => Promise<GetCustomSchemaResponse>, req: GetCustomSchemaRequest): { promise: () => Promise<GetCustomSchemaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCustomSchemaEndpoint),
      endpoint: GetCustomSchemaEndpoint
    };
  }

  export const GetCustomSchemaConnectionsEndpoint = "/grpc/fieldmeta.CustomSchemaServicePublic/GetCustomSchemaConnections";
  /** Retrieves the latest custom schema connections for an org and the requested parent entities. */
  export function GetCustomSchemaConnections(sender: (req: GetCustomSchemaConnectionsRequest, endpoint: string) => Promise<GetCustomSchemaConnectionsResponse>, req: GetCustomSchemaConnectionsRequest): { promise: () => Promise<GetCustomSchemaConnectionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCustomSchemaConnectionsEndpoint),
      endpoint: GetCustomSchemaConnectionsEndpoint
    };
  }

  export const GetCustomSchemaConnectionsByPropertyEndpoint = "/grpc/fieldmeta.CustomSchemaServicePublic/GetCustomSchemaConnectionsByProperty";
  /**
   * Retrieves the latest custom schema connections for an org by property.
   * If possible, prefer GetCustomSchemaConnections by parent as it's cheaper and more efficient.
   */
  export function GetCustomSchemaConnectionsByProperty(sender: (req: GetCustomSchemaConnectionsByPropertyRequest, endpoint: string) => Promise<GetCustomSchemaConnectionsResponse>, req: GetCustomSchemaConnectionsByPropertyRequest): { promise: () => Promise<GetCustomSchemaConnectionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCustomSchemaConnectionsByPropertyEndpoint),
      endpoint: GetCustomSchemaConnectionsByPropertyEndpoint
    };
  }
}

export namespace CustomSchemaAdminService {

  export const DeleteCustomSchemaEndpoint = "/grpc/fieldmeta.CustomSchemaAdminService/DeleteCustomSchema";
  /** Deletes custom schema fields from persisted data. */
  export function DeleteCustomSchema(sender: (req: DeleteCustomSchemaRequest, endpoint: string) => Promise<DeleteCustomSchemaResponse>, req: DeleteCustomSchemaRequest): { promise: () => Promise<DeleteCustomSchemaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteCustomSchemaEndpoint),
      endpoint: DeleteCustomSchemaEndpoint
    };
  }
}

export interface GetCustomSchemaRequest {
  orgId: string;
  forceFresh: boolean;
}

export interface GetCustomSchemaInternalResponse {
  /** The latest custom schema data for the org. */
  customSchema: CustomSchema | null;
  /**
   * The latest custom schema cardinality counts for data ingested for the org.
   * Note: The event property counts may be higher than the number of unscoped event properties in the custom schema.
   *       For historical reasons, event properties are counted and limited based on connections and not unscoped props.
   */
  customSchemaCounts: CustomSchemaCounts | null;
  /** The limits that apply for the org. Custom schema cardinality cannot go above these limits. */
  customSchemaLimits: CustomSchemaCounts | null;
}

export interface GetCustomSchemaResponse {
  /** The latest custom schema data for the org. */
  customSchema: CustomSchema | null;
  /**
   * The latest custom schema cardinality counts for data ingested for the org.
   * Note: The event property counts may be higher than the number of unscoped event properties in the custom schema.
   *       For historical reasons, event properties are counted and limited based on connections and not unscoped props.
   */
  customSchemaCounts: CustomSchemaCounts | null;
  /** The limits that apply for the org. Custom schema cardinality cannot go above these limits. */
  customSchemaLimits: CustomSchemaCounts | null;
}

export interface GetCustomSchemaConnectionsRequest {
  orgId: string;
  /**
   * Page definition ids for which connected properties should be
   * retrieved.
   */
  pages: number[];
  /** Event names for which connected properties should be retrieved. */
  events: string[];
  /** Element ids for which connected properties should be retrieved. */
  elements: string[];
  forceFresh: boolean;
}

export interface GetCustomSchemaConnectionsByPropertyRequest {
  orgId: string;
  /** Properties for which connections should be retrieved. */
  properties: GetCustomSchemaConnectionsByPropertyRequest.Property[];
  /** Optional scope for desired connection type (if unset, will retrieve all scopes). */
  scope: vars.Scope;
}

export namespace GetCustomSchemaConnectionsByPropertyRequest {
  export interface Property {
    /** Simple unscoped untyped property name for this connection. */
    name: string;
    /** Property type for this connection. */
    type: vars.Type;
  }
}

export interface GetCustomSchemaConnectionsResponse {
  /** The custom schema connections for the requested entities. */
  customSchemaConnections: CustomSchemaConnections | null;
}

export interface IndexCustomSchemaRequest {
  orgId: string;
  /**
   * Subset of custom schema that is being indexed.
   * Response will indicate which pieces are allowed.
   */
  customSchema: CustomSchemaWithMetadata | null;
  /**
   * Subset of connections that are being indexed.
   * As long as the property is allowed to be indexed, the connection will be indexed as well.
   */
  customSchemaConnections: CustomSchemaConnectionsWithMetadata | null;
  /** The indv sample value for which the fields are being indexed. */
  indvSample: number;
}

export interface IndexCustomSchemaResponse {
  /**
   * If all allowed is true, no need to check other fields.
   * It is assumed all requested custom schema data is okay to let through.
   */
  allAllowed: boolean;
  /** If not all allowed, explicitly indicates which custom schema data is allowed. */
  customSchemaAllowed: CustomSchema | null;
  /**
   * If not all allowed, explicitly indicates which custom schema data is ignored and thus shouldn't trigger errors
   * when blocked from ingestion.
   */
  customSchemaIgnored: CustomSchema | null;
  /**
   * If not all allowed, explicitly indicates connections allowed.
   * TODO: remove if/when we enforce cardinality solely off of unscoped properties, ideally connections would not be cardinality limited
   */
  customSchemaConnectionsAllowed: CustomSchemaConnections | null;
  /**
   * If not all allowed, explicitly indicates which connections should be ignored thus shouldn't trigger errors
   * when blocked from ingestion (if applicable).
   * TODO: remove if/when we enforce cardinality solely off of unscoped properties, ideally connections would not be cardinality limited
   */
  customSchemaConnectionsIgnored: CustomSchemaConnections | null;
}

export interface DeleteCustomSchemaRequest {
  orgId: string;
  commit: boolean;
  type: DeleteCustomSchemaRequest.Type;
  field: string;
  /** if set, applies a parent restriction */
  parent: string;
  /** if true, deletes all fields with field prefix, does *not* apply to parent */
  treatFieldAsPrefix: boolean;
}

export namespace DeleteCustomSchemaRequest {
  export enum Type {
    TYPE_INVALID = 0,
    TYPE_USER_PROPERTY = 1,
    TYPE_PAGE_PROPERTY = 2,
    /** if chosen, also deletes event properties for any matching events */
    TYPE_EVENT = 3,
    TYPE_EVENT_PROPERTY = 4,
    TYPE_ELEMENT_PROPERTY = 5
  }
}

export interface DeleteCustomSchemaResponse {
  committed: boolean;
  deleted: CustomSchema | null;
  deletedConnections: CustomSchemaConnections | null;
}

export interface CustomSchema {
  userProperties: UserProperty[];
  pageProperties: PageProperty[];
  events: Event[];
  eventProperties: EventProperty[];
  elementProperties: ElementProperty[];
}

export interface CustomSchemaWithMetadata {
  userProperties: UserProperty[];
  pageProperties: PageProperty[];
  eventsAndMetadata: EventAndMetadata[];
  eventProperties: EventProperty[];
  elementProperties: ElementProperty[];
}

export interface CustomSchemaCounts {
  userProperties: number;
  pageProperties: number;
  events: number;
  eventProperties: number;
  elementProperties: number;
}

export interface UserProperty {
  /** Simple unscoped untyped name, assumed to be a user var. */
  name: string;
  /** Var type of this user property. */
  type: vars.Type;
  /** Approximate last seen time for this user property (<= actual last seen, typically within 24 hours of actual last seen). */
  approximateLastSeen: protobuf.timestamp | null;
}

export interface PageProperty {
  /** Simple unscoped untyped name, assumed to be a page var. */
  name: string;
  /** Var type of this page property. */
  type: vars.Type;
  /** Approximate last seen time for this page property (<= actual last seen, typically within 24 hours of actual last seen). */
  approximateLastSeen: protobuf.timestamp | null;
}

export interface Event {
  /** Event name. */
  name: string;
  /** Approximate last seen time for this event (<= actual last seen, typically within 24 hours of actual last seen). */
  approximateLastSeen: protobuf.timestamp | null;
}

export interface EventAndMetadata {
  /** Event name. */
  name: string;
  /** Approximate last seen time for this event (<= actual last seen, typically within 24 hours of actual last seen). */
  approximateLastSeen: protobuf.timestamp | null;
  /** Capture source integration for Spec mapping. Uses a map in place of a list since proto sets aren't supported. */
  captureSourceIntegrations: string[];
}

export interface EventProperty {
  /** Simple unscoped untyped name, assumed to be an event var. */
  name: string;
  /** Var type of this event property. */
  type: vars.Type;
  /**
   * Approximate last seen time for this event property scoped to this event name (<= actual last seen, typically within 24 hours of actual last
   * seen).
   */
  approximateLastSeen: protobuf.timestamp | null;
}

export interface ElementProperty {
  /** Simple unscoped untyped name, assumed to be an element var. */
  name: string;
  /** Var type of this element property. */
  type: vars.Type;
  /** Approximate last seen time for this element property (<= actual last seen, typically within 24 hours of actual last seen). */
  approximateLastSeen: protobuf.timestamp | null;
}

export interface CustomSchemaConnections {
  /** Page connections keyed by page definition id. */
  pageConnections: { [key: string]: CustomSchemaConnections.Connections };
  /** Event connections keyed by event name. */
  eventConnections: { [key: string]: CustomSchemaConnections.Connections };
  /** Element connections keyed by element id. */
  elementConnections: { [key: string]: CustomSchemaConnections.Connections };
}

export namespace CustomSchemaConnections {
  export interface Connections {
    properties: CustomSchemaConnections.Property[];
  }

  export interface Property {
    /** Simple unscoped untyped property name for this connection. */
    name: string;
    /** Property type for this connection. */
    type: vars.Type;
    /** Approximate last seen time for this property connection. */
    approximateLastSeen: protobuf.timestamp | null;
  }
}

export interface CustomSchemaConnectionsWithMetadata {
  /** Page connections keyed by page definition id. */
  pageConnections: { [key: string]: CustomSchemaConnectionsWithMetadata.Connections };
  /** Event connections keyed by event name. */
  eventConnections: { [key: string]: CustomSchemaConnectionsWithMetadata.Connections };
  /** Element connections keyed by element id. */
  elementConnections: { [key: string]: CustomSchemaConnectionsWithMetadata.Connections };
}

export namespace CustomSchemaConnectionsWithMetadata {
  export interface Connections {
    properties: CustomSchemaConnectionsWithMetadata.PropertyAndMetadata[];
  }

  export interface PropertyAndMetadata {
    /** Simple unscoped untyped property name for this connection. */
    name: string;
    /** Property type for this connection. */
    type: vars.Type;
    /** Approximate last seen time for this property connection. */
    approximateLastSeen: protobuf.timestamp | null;
    /** Capture source integrations for use by Spec matching. Uses a map in place of a list since proto sets aren't supported. */
    captureSourceIntegrations: string[];
  }
}

export interface ConnectedProperty {
  /** The scope of connected property. Implies parent key meaning. */
  scope: vars.Scope;
  /**
   * The parent key of the connected property.
   * Scope_page: page definition id
   * Scope_evt: event name
   * Scope_elem: element id
   */
  parentKey: string;
  /** Simple unscoped untyped property name for this connection. */
  propertyName: string;
  /** Property type for this connection. */
  propertyType: vars.Type;
  /** Approximate last seen time for this property connection. */
  approximateLastSeen: protobuf.timestamp | null;
}
